export type IntentKind = 'data_query' | 'device_action' | 'workflow_trigger' | 'conversation';

export interface IntentDecomposedEvent {
  messageId: string;
  intents: Array<{ id: string; kind: IntentKind; text: string }>;
}

export interface SubIntentStatusEvent {
  messageId: string;
  intentId: string;
  stage: string;
  thought: string;
}

export interface SubIntentResultEvent {
  messageId: string;
  intentId: string;
  status: 'ok' | 'failed';
  summary: string;
}

export interface SynthesisStartEvent {
  messageId: string;
}

export interface ResponseTokenEvent {
  messageId: string;
  chunk: string;
  done: boolean;
}

export const DECOMPOSER_INTENT_ID = '__decomposer__';
export const SYNTHESIZER_INTENT_ID = '__synthesizer__';
